import React from 'react';
import { Phone, Calendar, Star, Zap, Shield, Award } from 'lucide-react';
import { Button } from '../ui/button';

export const Hero = () => {
  return (
    <section data-testid="hero-section" className="relative py-20 md:py-32 overflow-hidden bg-[#0A0E27]">
      <div className="absolute inset-0">
        <div className="absolute top-20 right-20 w-[500px] h-[500px] bg-[#0066FF]/15 rounded-full blur-[120px]" />
        <div className="absolute bottom-20 left-20 w-[400px] h-[400px] bg-[#00D9FF]/10 rounded-full blur-[100px]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#0066FF]/5 rounded-full blur-[150px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          <div className="inline-block mb-8">
            <div className="flex items-center space-x-3 bg-white/5 backdrop-blur-md px-6 py-3 rounded-full border border-white/10">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <span className="text-white font-bold text-sm">5.0 Rating</span>
              <span className="text-gray-500">|</span>
              <span className="text-[#00D9FF] font-bold text-sm">Ballito's HVAC Experts</span>
            </div>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-black text-white leading-tight mb-6">
            All Your Climate Needs.
            <br />
            <span className="bg-gradient-to-r from-[#00D9FF] to-[#0066FF] text-transparent bg-clip-text">
              One Expert Team.
            </span>
          </h1>

          <p className="text-base md:text-lg text-gray-400 leading-relaxed mb-10 max-w-3xl mx-auto">
            From repairs to installations, servicing to maintenance contracts — Chill Point is the only call you need to make. Heating & cooling experts trusted across Ballito & the North Coast.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button size="lg" className="bg-gradient-to-r from-[#0066FF] to-[#00D9FF] hover:from-[#0052CC] hover:to-[#00B8D4] text-white text-lg px-10 py-7 rounded-xl shadow-2xl shadow-blue-500/25 font-bold border border-cyan-400/20 transform hover:scale-105 transition-all" data-testid="hero-book-btn">
              <a href="/book" className="flex items-center space-x-3">
                <Calendar className="w-5 h-5" />
                <span>Book Online</span>
              </a>
            </Button>
            <Button size="lg" className="bg-white/5 backdrop-blur-md hover:bg-white/10 text-white text-lg px-10 py-7 rounded-xl border border-white/20 font-bold transform hover:scale-105 transition-all" data-testid="hero-call-btn">
              <a href="tel:0644505026" className="flex items-center space-x-3">
                <Phone className="w-5 h-5" />
                <span>Call: 064 450 5026</span>
              </a>
            </Button>
          </div>

          <div className="grid grid-cols-3 gap-4 md:gap-6 max-w-3xl mx-auto">
            {[
              { icon: <Zap className="w-5 h-5" />, text: 'Same-Day Service', color: 'from-yellow-400 to-orange-500' },
              { icon: <Shield className="w-5 h-5" />, text: 'Heating & Cooling', color: 'from-green-400 to-emerald-500' },
              { icon: <Award className="w-5 h-5" />, text: '100+ Happy Clients', color: 'from-blue-400 to-cyan-500' }
            ].map((item, i) => (
              <div key={i} className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl p-4 hover:bg-white/10 transition-all group">
                <div className={`w-10 h-10 bg-gradient-to-br ${item.color} rounded-lg flex items-center justify-center mx-auto mb-3 text-white group-hover:scale-110 transition-transform`}>
                  {item.icon}
                </div>
                <p className="text-white font-semibold text-xs sm:text-sm">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
